import { FormProvider } from 'react-hook-form';
import { Heading, LiliMultiSelect } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ControllerWrapper } from '@Hooks/index';
import { FieldError } from '@Components/inputs/FieldError';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { worldCountires } from '@Pages/happyFlowPages/eddQuestions/hooks/worldCountries';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { Icon, Icons } from '@Components/icon/Icon';
import { EddEmbeddedFields } from '../../embedded/fields.types';
import { useLogic } from './hooks/useLogic';

export const EddInternationalActivity = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, reactiveInternationalActivityList } = useLogic();
  const defaultUsValue = 'US';
  const defaultOtherValue = 'OTHER';

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.internationalActivity.content')}
        content={t('organic.internationalActivity.question')}
        formMethods={formMethods}
        handleSubmit={() => handleSubmit()}
        textCustomStyle='mt-[16px] text-text-main-primary text-[16px] whitespace-pre-line'
        headingContainerCustomStyle='!mb-[16px]'>
        <ControllerWrapper name={EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY}>
          {({ onChange, error }) => (
            <div className='flex flex-col gap-4'>
              <CustomRadioButton
                label={t('organic.internationalActivity.radioA')}
                value={defaultUsValue}
                inputId='US'
                onChange={(val) => {
                  onChange([val]);
                }}
                checked={reactiveInternationalActivityList.includes(defaultUsValue)}
                name=''
              />
              <CustomRadioButton
                label={t('organic.internationalActivity.radioB')}
                value={defaultOtherValue}
                inputId='OTHER'
                onChange={(val) => {
                  onChange([val]);
                }}
                checked={
                  !!reactiveInternationalActivityList.length &&
                  !reactiveInternationalActivityList.includes(defaultUsValue)
                }
                name=''
              />
              {!!reactiveInternationalActivityList.length &&
                !reactiveInternationalActivityList.includes(defaultUsValue) && (
                  <>
                    <Heading.H10 className='text-text-main-tertiary'>
                      {t('organic.internationalActivity.disclaimer')}
                    </Heading.H10>
                    <div id='multi-select-wrapper' className='w-full'>
                      <LiliMultiSelect
                        closeIcon={<Icon icon={Icons.ExitIcon} />}
                        activeIcon={
                          <Icon
                            className='stroke-text-brand-primary text-text-brand-primary'
                            icon={Icons.Success}
                          />
                        }
                        placeholder={t('organic.internationalActivity.selectCountryPlaceholder')}
                        maxSelectedLabels={3}
                        items={worldCountires}
                        onChange={(list) => onChange(list.length > 0 ? list : [defaultOtherValue])}
                        defaultValue={reactiveInternationalActivityList.filter(
                          (item) => item !== defaultOtherValue
                        )}
                      />
                    </div>
                  </>
                )}
              <FieldError
                error={error}
                testId={`${EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY}-error`}
              />
            </div>
          )}
        </ControllerWrapper>
      </StepPageWrapper>
    </FormProvider>
  );
};
